import React from 'react';
import PropTypes from 'prop-types';

import { Tag } from 'edcom-ui';
import AppLink from '../links/AppLink';

import styles from './CategoryTree.module.less';
import Standards from './Standards';

const CategoryTree = ({ resource, isNewTaxonomy }) => {
  const { grades = [], subjects = [], standards } = resource;
  const standardOptions = [
    {
      name: 'USA',
      options: [
        {
          name: 'Common Core State Standards',
          internalName: 'CCSS',
        },
        {
          name: 'Texas Essential Knowledge and Skills (TEKS)',
          internalName: 'TEKS',
        },
        {
          name: 'Virginia Standards of Learning (SOL)',
          internalName: 'SOL',
        },
        {
          name: 'Next Generation Science Standards (NGSS)',
          internalName: 'NGSS',
        },
      ],
    },
    {
      name: 'Canada',
      options: [
        {
          name: 'BC Performance Standards',
          internalName: 'BC',
        },
        {
          name: 'Alberta Program of Studies',
          internalName: 'Alberta',
        },
      ],
    },
    {
      name: 'Australia',
      options: [
        {
          name: 'The Australian Curriculum (ACARA)',
          internalName: 'ACARA',
        },
        {
          name: 'The Victorian Curriculum (F-10)',
          internalName: 'F-10',
        },
      ],
    },
  ];

  let gradesToShow = null;

  if (isNewTaxonomy) {
    if (grades && grades.length) {
      const gradesList = grades.map(elem => {
        const link = (
          <AppLink href={`/resources/${elem.urlSlice}/`}>{elem.name}</AppLink>
        );
        return (
          <Tag key={elem.urlSlice} className={styles.tag}>
            {link}
          </Tag>
        );
      });
      gradesToShow = (
        <>
          <h5 className={styles.title}>Grade</h5>
          <div className={styles.values}>{gradesList}</div>
        </>
      );
    }
  } else {
    if (grades.length) {
      const gradesList = grades.map(elem => {
        const link = (
          <AppLink href={`/resources/${elem.urlName}/`}>{elem.name}</AppLink>
        );
        return (
          <Tag key={elem.urlName} className={styles.tag}>
            {link}
          </Tag>
        );
      });
      gradesToShow = (
        <>
          <h5 className={styles.title}>Grade</h5>
          <div className={styles.values}>{gradesList}</div>
        </>
      );
    }
  }

  let subjectsToShow = null;
  if (!isNewTaxonomy && subjects.length) {
    const subjectsList = subjects.map(elem => {
      const link = (
        <AppLink href={`/resources/${elem.urlName}/`}>{elem.name}</AppLink>
      );
      return (
        <Tag key={elem.urlName} className={styles.tag}>
          {link}
        </Tag>
      );
    });
    subjectsToShow = (
      <>
        <h5 className={styles.title}>Subject</h5>
        <div className={styles.values}>{subjectsList}</div>
      </>
    );
  }
  // some resources do not have standards, e.g (some) hands-on activities
  let standardsSection = null;
  if (standards) {
    standardsSection = (
      <>
        <h5 className={styles.title}>View aligned standards</h5>
        <Standards standardOptions={standardOptions} standards={standards} />
      </>
    );
  }

  return (
    <>
      {gradesToShow}
      {subjectsToShow}
      {standardsSection}
    </>
  );
};

CategoryTree.propTypes = {
  resource: PropTypes.shape({
    id: PropTypes.number,
    grades: PropTypes.array,
    subjects: PropTypes.array,
    standards: PropTypes.arrayOf(
      PropTypes.shape({
        urlName: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  isNewTaxonomy: PropTypes.bool.isRequired,
};

export default CategoryTree;
